import { ICursorElements, IState } from '@/store/types/search.types';

import { IOnboardingUser, TOnboardingUserType } from '@/store/models/onboarding-user.model';
import { TAppError, IBaseAction } from '@/store/types/base.state';

export enum OnboardingUserActionTypes {
  FETCH_ONBOARDING_USERS = 'ONBOARDING_USER.FETCH_ONBOARDING_USERS',
  FETCH_ONBOARDING_USERS_SUCCESS = 'ONBOARDING_USER.FETCH_ONBOARDING_USERS_SUCCESS',
  FETCH_ONBOARDING_USERS_FAIL = 'ONBOARDING_USER.FETCH_ONBOARDING_USERS_FAIL',
}

export interface IFetchOnboardingUserAction extends IBaseAction {
  type: typeof OnboardingUserActionTypes.FETCH_ONBOARDING_USERS;
  onboardingUserType: TOnboardingUserType;
}

export interface IFetchOnboardingUserSuccessAction extends IBaseAction {
  type: typeof OnboardingUserActionTypes.FETCH_ONBOARDING_USERS_SUCCESS;
  onboardingUserType: TOnboardingUserType;
  paginateOnboardingUsers?: ICursorElements<IOnboardingUser>;
  isClear?: boolean;
}

export interface IFetchOnboardingUserFailAction extends IBaseAction {
  type: typeof OnboardingUserActionTypes.FETCH_ONBOARDING_USERS_FAIL;
  onboardingUserType: TOnboardingUserType;
  error: TAppError;
}

export type TOnboardingUserAction =
  | IFetchOnboardingUserAction
  | IFetchOnboardingUserSuccessAction
  | IFetchOnboardingUserFailAction;

export type TOnboardingUserState = Record<TOnboardingUserType, IState<ICursorElements<IOnboardingUser>>>;
